export const postalCodeValidation = {
  type: 'number',
  min: 0,
  // prevent special characters in type number, right now we're only allowing numbers as we're only supporting zipcodes from the US
  onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === '-' || e.key === '+' || e.key === '.' || e.key === ',' || e.key === 'e') e.preventDefault();
  },
};
